/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const loopSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  hasIntegratedItems: z.boolean(),
  id: z.int(),
  itemCount: z.int(),
  lastScheduledAt: z.iso.datetime().nullish(),
  name: z.string(),
  organizationId: z.string(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
